import { ValueElement } from "./Base";

export default class SelectElement extends ValueElement {
  private instance: HTMLSelectElement;

  private onChangeClick = () => { this.onChange(); }

  constructor(name: string,
              classes: string[] = [],
              options: Array<{value: string, text: string}> = []) {
    super(name);
    this.instance = document.createElement("select");
    this.instance.setAttribute("name", name);
    this.instance.setAttribute("id", name);
    this.instance.classList.add(...classes);

    options.forEach((opt: any) => {
        const option = document.createElement("option");
        option.value = opt.value;
        option.text = opt.text;
        option.selected = opt.selected;

        this.instance.options.add(option);
    });

    this.instance.addEventListener("change", this.onChangeClick);
  }

  get element(): HTMLElement {
    return this.instance;
  }

  get value(): any {
    return this.instance.value;
  }

  set value(val: any) {
    this.instance.value = val;
  }

  dispose(): void {
    this.instance.removeEventListener("change", this.onChangeClick);
  }

  disable(): void {
    this.instance.disabled = true;
  }
}
